import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Flame, FileText, AlertTriangle, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-slate-900 text-white pt-24 pb-20 px-6 relative overflow-hidden" data-id="element-83">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-84">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-red-600 blur-[120px]" data-id="element-85"></div>
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex justify-center mb-6" data-id="element-87">
          <div className="bg-red-900/40 border border-red-500/50 text-red-400 px-4 py-1.5 rounded-full text-sm font-bold flex items-center gap-2" data-id="element-88">
            <Flame size={16} data-id="element-89" />
            <span data-id="element-90">Oferta por tiempo limitado</span>
          </div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-offwhite" style={{
        fontFamily: 'Calibri, Carlito, sans-serif'
      }} data-id="element-91">
          Tus hijos no merecen heredar tus peleas. Aprendé a blindar tu celular
          y sacarlos del medio del conflicto hoy mismo.
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-slate-300 mb-6 leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-92">
          El manual definitivo para padres y madres que quieren dejar de vivir
          con taquicardia cada vez que vibra el WhatsApp.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.22
      }} className="flex flex-col items-center gap-3 mb-8 text-left max-w-md mx-auto" data-id="element-93">
          <div className="flex items-start gap-3" data-id="element-94">
            <CheckCircle2 className="text-green-500 flex-shrink-0 mt-0.5" size={20} data-id="element-95" />
            <span className="text-slate-200" data-id="element-96">
              Aprendé a responder sin escalar el conflicto
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-97">
            <CheckCircle2 className="text-green-500 flex-shrink-0 mt-0.5" size={20} data-id="element-98" />
            <span className="text-slate-200" data-id="element-99">
              Protegé la estabilidad emocional de tus hijos
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-100">
            <CheckCircle2 className="text-green-500 flex-shrink-0 mt-0.5" size={20} data-id="element-101" />
            <span className="text-slate-200" data-id="element-102">
              Recuperá tu paz mental en 7 días
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.25
      }} className="flex justify-center mb-10" data-id="element-103">
          <img src="https://cdn.magicpatterns.com/uploads/6Y89FF9V6qqKNd4MTtTi91/Gemini_Generated_Image_svxz38svxz38svxz.png" alt="Clave de Paz: Padres Separados - Manual en formato PDF" className="w-48 md:w-64 h-auto drop-shadow-2xl rounded-lg" data-id="element-104" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex justify-center mb-10" data-id="element-105">
          <div className="bg-slate-800 border border-slate-700 text-slate-300 px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2" data-id="element-106">
            <FileText size={16} className="text-amber-400" data-id="element-107" />
            <span data-id="element-108">Herramienta en formato PDF · Descarga inmediata</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col items-center" data-id="element-109">
          <a href="#offer" onClick={e => {
          e.preventDefault();
          document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="bg-red-600 hover:bg-red-700 text-white font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-lg shadow-red-600/30 transition-all transform hover:scale-105 active:scale-95 w-full sm:w-auto text-center" data-id="element-110">
            QUIERO EL MANUAL (PDF)
          </a>
          <p className="text-sm text-slate-400 mt-4 flex items-center gap-2 font-medium" data-id="element-111">
            <span data-id="element-112">
              Ebook digital (PDF). No es libro físico. Acceso inmediato tras el
              pago.
            </span>
          </p>
          <p className="text-xs text-slate-500 mt-3 flex items-center gap-2" data-id="element-113">
            <span data-id="element-114">Acceso inmediato</span>
            <span className="w-1 h-1 rounded-full bg-slate-600" data-id="element-115"></span>
            <span data-id="element-116">Pago único</span>
            <span className="w-1 h-1 rounded-full bg-slate-600" data-id="element-117"></span>
            <span data-id="element-118">100% seguro</span>
          </p>
        </motion.div>
      </div>
    </section>;
}